export default {"src":"/_next/static/media/icon_catalog_expandarrow.5a442b51.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};